<style scoped>
    @import url("../../../styles/smartControl/dialogTimer.scss");
</style>

<template>
    <div class="box_dialogTimer">

        <div class="painelTimer">

            <v-time-picker
                v-model="selectedTime"
                format="24hr"
            />

            <div class="btnTimer">
                
                <v-btn
                block
                @click="handleDialogChange()"
                color="#F39C12"
                >
                    Selecionar
                </v-btn>

            </div>

        </div>

    </div>
</template>

<script>
export default {

    data() {
        return {
            selectedTime:null, // ex.: "16:35"
        }
    },

    methods: {

        handleDialogChange() {
            const hrSelected = this.selectedTime
            //console.log(`[][handleDialogChange] hrSelected: ${hrSelected}`)
            this.$emit('fromDialog',hrSelected) // desable dialog.
        },
    },

    created() {
        //
    }
}
</script>